/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Subscribe to settings changes for the authenticated user
 */
export interface SettingsClientMessageOneOf {
    type: SettingsClientMessageOneOfTypeEnum;
    user_id: string;
}
export enum SettingsClientMessageOneOfTypeEnum {
    Subscribe = 'subscribe'
};
